import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Container } from 'react-bootstrap'

import Layout from '../layout/Layout'
import Showcase from '../sections/Showcase'
import Mission from '../sections/Mission'
import Testimonials from '../sections/Testimonials'
import Teams from '../sections/Teams'
import Leaders from '../sections/Leaders'
import Contact from '../sections/Contact'


import '../styles/index.scss';

const Home = () => {

  return (
    <Layout>
        <Container id='home'>
          <Showcase />
        </Container>
        <Mission />
        <Testimonials />
        <Teams />
        <Leaders />
        <Contact />
    </Layout>
  )
}

export default Home
